import { FullscreenSpinner } from '@festina-life/ui/feedback'
import type { ReactNode } from 'react'

import { useSetupFPlusViewer } from '../hooks/useSetupFPlusViewer'

type Props = {
  children: ReactNode
}

export const FPlusProvider = ({ children }: Props) => {
  const { isReady: isFPlusViewerReady } = useSetupFPlusViewer()

  if (!isFPlusViewerReady) {
    return <FullscreenSpinner />
  }

  return children
}
